import { createSelector } from 'reselect';

// selectors
const getDecisions = (state) => state.decisions;
const getLoading = (state) => state.loading?.isLoading;
const getLanguage = (state) => state.config?.language;
const getDeviceInteraction = (state) => state.config?.deviceInteraction;

// reselect function
export const getDecisionsState = createSelector(
    [getDecisions, getLoading, getLanguage, getDeviceInteraction],
    (decisions, isLoading, language, deviceInteraction) => (
        {
            decisions,
            isLoading,
            language,
            deviceInteraction
        }
    )
);
